import { render, staticRenderFns } from "./speakers.vue?vue&type=template&id=5572a2a0&"
import script from "./speakers.vue?vue&type=script&lang=js&"
export * from "./speakers.vue?vue&type=script&lang=js&"
import style0 from "./speakers.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports